import { BaseModel, type RelationConfig } from './base';
import { Employee } from './employee';
import type { Service } from './service';

export class EmployeeService extends BaseModel {
  idEmployeeService?: number;
  service?: Service;
  employee?: Employee;
  duration?: number;
  processing?: number;
  finishing?: number;
  price?: number;
  allowInternet?: boolean;
  allowedDaysOfWeek?: { [key: string]: boolean };
  allowedDays?: { [key: string]: boolean };

  override objectID(): string {
    return this.idEmployeeService?.toString() || '';
  }

  static override relations(): RelationConfig {
    return {
      employee: { type: Employee },
    };
  }

  get availableDaysLabel(): string {
    const allowedDaysOfWeek = this.allowedDaysOfWeek || this.allowedDays;
    const isAllowedAllDays = Object.values(allowedDaysOfWeek || {}).every(item => !!item);
    const isAllowedNoDays = Object.values(allowedDaysOfWeek || {}).every(item => !item);

    if (isAllowedAllDays) return 'general.all';
    if (isAllowedNoDays) return 'general.none';
    return 'employee.limited';
  }

  get isAllowedDaysAll(): boolean {
    const allowedDaysOfWeek = this.allowedDaysOfWeek || this.allowedDays;
    return Object.values(allowedDaysOfWeek || {}).every(item => !!item);
  }

  get isAllowedDaysNone(): boolean {
    const allowedDaysOfWeek = this.allowedDaysOfWeek || this.allowedDays;
    return Object.values(allowedDaysOfWeek || {}).every(item => !item);
  }

  get isAllowedDaysLimited(): boolean {
    return !this.isAllowedDaysAll && !this.isAllowedDaysNone;
  }
} 